"use strict";

exports.__esModule = true;
exports.SHOPPABLE_PLUGIN = exports.QUERY_STRING_PARAM_STRATEGY = exports.GTM_LOCALSTORAGE_DATA = exports.GTM_EVENT_PAGE_TEMPLATE = exports.FIELD_NAME_VARIANT_AND_ICON = exports.API_HTTP_STATUS_CODE = void 0;

let QUERY_STRING_PARAM_STRATEGY = /*#__PURE__*/function (QUERY_STRING_PARAM_STRATEGY) {
  QUERY_STRING_PARAM_STRATEGY["STRING"] = "string";
  QUERY_STRING_PARAM_STRATEGY["ARRAY"] = "array";
  return QUERY_STRING_PARAM_STRATEGY;
}({});

exports.QUERY_STRING_PARAM_STRATEGY = QUERY_STRING_PARAM_STRATEGY;

let GTM_EVENT_PAGE_TEMPLATE = /*#__PURE__*/function (GTM_EVENT_PAGE_TEMPLATE) {
  GTM_EVENT_PAGE_TEMPLATE["home"] = "homepage";
  GTM_EVENT_PAGE_TEMPLATE["article"] = "article_page";
  GTM_EVENT_PAGE_TEMPLATE["product"] = "product_page";
  GTM_EVENT_PAGE_TEMPLATE["productList"] = "products_list_page";
  GTM_EVENT_PAGE_TEMPLATE["searchResults"] = "search_results_page";
  GTM_EVENT_PAGE_TEMPLATE["contactUs"] = "contact_us_page";
  GTM_EVENT_PAGE_TEMPLATE["login"] = "login_page";
  GTM_EVENT_PAGE_TEMPLATE["signUp"] = "sign_up_page";
  GTM_EVENT_PAGE_TEMPLATE["other"] = "other_page";
  return GTM_EVENT_PAGE_TEMPLATE;
}({});

exports.GTM_EVENT_PAGE_TEMPLATE = GTM_EVENT_PAGE_TEMPLATE;

let API_HTTP_STATUS_CODE = /*#__PURE__*/function (API_HTTP_STATUS_CODE) {
  API_HTTP_STATUS_CODE[API_HTTP_STATUS_CODE["OK"] = 200] = "OK";
  API_HTTP_STATUS_CODE[API_HTTP_STATUS_CODE["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  API_HTTP_STATUS_CODE[API_HTTP_STATUS_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  return API_HTTP_STATUS_CODE;
}({});

exports.API_HTTP_STATUS_CODE = API_HTTP_STATUS_CODE;

let SHOPPABLE_PLUGIN = /*#__PURE__*/function (SHOPPABLE_PLUGIN) {
  SHOPPABLE_PLUGIN["ADIMO"] = "Adimo";
  SHOPPABLE_PLUGIN["MIKMAK_DEPRECATED"] = "MikMak";
  SHOPPABLE_PLUGIN["MIKMAK_V1"] = "MikMak v1";
  SHOPPABLE_PLUGIN["MIKMAK_V2"] = "MikMak v2";
  SHOPPABLE_PLUGIN["PRICE_SPIDER"] = "Price spider";
  return SHOPPABLE_PLUGIN;
}({});

exports.SHOPPABLE_PLUGIN = SHOPPABLE_PLUGIN;

let GTM_LOCALSTORAGE_DATA = /*#__PURE__*/function (GTM_LOCALSTORAGE_DATA) {
  GTM_LOCALSTORAGE_DATA["lastRetailerTitle"] = "LAST_RETAILER_TITLE";
  GTM_LOCALSTORAGE_DATA["lastProductIndex"] = "LAST_PRODUCT_INDEX";
  return GTM_LOCALSTORAGE_DATA;
}({});

exports.GTM_LOCALSTORAGE_DATA = GTM_LOCALSTORAGE_DATA;
const FIELD_NAME_VARIANT_AND_ICON = 'Variant_And_Icon';
exports.FIELD_NAME_VARIANT_AND_ICON = FIELD_NAME_VARIANT_AND_ICON;